import React, { useState } from 'react'
import styled from 'styled-components'
import img from '../assets/portfolio.jpg'
import { FaAngleRight } from 'react-icons/fa'
import Modal from './Modal'

const Wrapper = styled.div`
    display: inline-block;
    width: 100%;
    align-items: center;
    white-space: normal;
    .container {
        display: flex;
        .img {
            width: 50%;
            background-color: black;
            border-radius: 10px;
            margin-right: 24px;
        }
        .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: start;
            gap: 16px;
            text-align: left;
            .title {
                font-weight: 600;
                font-size: 20px;
            }
            .subtitle {
                font-weight: 500;
                font-size: 16px;
            }
            .verMais {
                display: flex;
                gap: 12px;
                align-items: center;
                justify-self: flex-start;
                
                padding: 12px 16px;
                border: none;
                border-radius: 6px;
                background-color: #e2b66b;
    
                font-weight: 500;
                font-size: 18px;
            }
        }
    }
`

function Card() {
    const [ isOpen, setIsOpen ] = useState(false)
    return (
        <Wrapper>
            <div className='container'>
                <img className='img' alt='portfolio' src={img} />
                <div className='content'>
                    <p className='title'>Calendário Editorial</p>
                    <p className='subtitle'>Calendário editorial quinzenal feito para um perfil de culinária no instagram em julho de 2021.</p>
                    <button onClick={() => setIsOpen(true)} className='verMais'>
                        <span>Ver Mais</span>
                        <FaAngleRight />
                    </button>
                    <Modal open={isOpen} onClose={() => setIsOpen(false)} />
                </div>
            </div>
        </Wrapper>
    );
}

export default Card;